import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTheme, useMediaQuery } from '@mui/material';
import DesktopLayout from './DesktopLayout';
import Clients from '../pages/Clients';

const ClientsDesktopShell = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const location = useLocation();
  const hasDetail = !/^\/clients\/?$/.test(location.pathname);

  if (!isDesktop) {
    return hasDetail ? <Outlet /> : <Clients />;
  }

  return (
    <DesktopLayout mode="chats" listContent={<Clients />} detailContent={hasDetail ? <Outlet /> : null} />
  );
};

export default ClientsDesktopShell;
